var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIosCheckboxOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ios-checkbox-outline",
    transform: "translate(-6 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38925",
    "data-name": "Path 38925",
    d: "M39,6H9A3,3,0,0,0,6,9V39a3,3,0,0,0,3,3H39a3,3,0,0,0,3-3V9A3,3,0,0,0,39,6Zm.375,32.625a.752.752,0,0,1-.75.75H9.375a.752.752,0,0,1-.75-.75V9.375a.752.752,0,0,1,.75-.75h29.25a.752.752,0,0,1,.75.75Z",
    fill: "#0267c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38926",
    "data-name": "Path 38926",
    d: "M34.088,18.084l-1.65-1.7a.355.355,0,0,0-.262-.112.34.34,0,0,0-.263.112L20.475,27.909l-4.162-4.163a.363.363,0,0,0-.525,0l-1.669,1.669a.374.374,0,0,0,0,.534l5.25,5.25a1.66,1.66,0,0,0,1.1.534,1.74,1.74,0,0,0,1.088-.516h.009L34.1,18.619a.4.4,0,0,0-.009-.534Z",
    fill: "#0267c1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosCheckboxOutline);
export default __webpack_public_path__ + "static/media/ios-checkbox-outline.f54ac9123c0b5d2c21b7cc0f9742d514.svg";
export { ForwardRef as ReactComponent };